const colors = {
  base: '#d8345f',
  dark: '#ba2b50',
  copy: '#a13f58',
  heart: '#d8345f',
  heartHead: '#a13f58',
};

export default colors;